"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const QDialogs_1 = __importDefault(require("components/QDialogs"));
const query_string_1 = __importDefault(require("query-string"));
const compose_1 = __importDefault(require("utils/compose"));
const immutable_1 = require("immutable");
const memoize_one_1 = __importDefault(require("memoize-one"));
const luxon_1 = require("luxon");
const uuid_1 = require("uuid");
const react_router_dom_1 = require("react-router-dom");
const auth_1 = require("companion-app-components/flux/auth");
const accounts_1 = require("companion-app-components/flux/accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const budgetsSelectors = __importStar(require("companion-app-components/flux/budgets/budgetsSelectors"));
const categories_1 = require("companion-app-components/flux/categories");
const accountsSelectors_1 = require("companion-app-components/flux/accounts/accountsSelectors");
const budget_items_1 = require("companion-app-components/flux/budget-items");
const budgetsActions_1 = require("companion-app-components/flux/budgets/budgetsActions");
const preferencesSelectors = __importStar(require("companion-app-components/flux/preferences/selectors"));
const actions_1 = require("companion-app-components/flux/preferences/actions");
const categoryGroupsActions_1 = require("companion-app-components/flux/category-groups/categoryGroupsActions");
const categoryGroupsSelectors = __importStar(require("companion-app-components/flux/category-groups/categoryGroupsSelectors"));
const categoryGroupListsActions_1 = require("companion-app-components/flux/category-group-lists/categoryGroupListsActions");
const categoryGroupListsSelectors = __importStar(require("companion-app-components/flux/category-group-lists/categoryGroupListsSelectors"));
const utils_1 = require("data/transactions/utils");
const selectors_1 = require("data/transactions/selectors");
const UIState_1 = __importDefault(require("components/UIState"));
const BudgetsV2_1 = __importDefault(require("./BudgetsV2"));
const transactionFilterFnGUID = (0, uuid_1.v4)();
const transactionFilterFn = (transaction, props) => {
    var _a;
    let keepTransaction = !(transaction.source === 'SCHEDULED_TRANSACTION_PENDING');
    keepTransaction = (keepTransaction && ((_a = props === null || props === void 0 ? void 0 : props.excludedAccounts) === null || _a === void 0 ? void 0 : _a.size) > 0) ? !props.excludedAccounts.includes(transaction.accountId) : keepTransaction;
    keepTransaction = (keepTransaction && props.accountIds && props.accountIds.size > 0) ? props.accountIds.has(transaction.accountId) : keepTransaction;
    const postedOnDate = luxon_1.DateTime.fromISO(transaction.postedOn).toJSDate();
    keepTransaction = (keepTransaction && props.startDate) ? postedOnDate >= props.startDate : keepTransaction;
    keepTransaction = (keepTransaction && props.endDate) ? postedOnDate <= props.endDate : keepTransaction;
    keepTransaction = (keepTransaction && props.coas && props.coas.size > 0) ? Boolean((transaction.coa && props.coas.find((coa) => coa.type === transaction.coa.type && coa.id === transaction.coa.id
        && (transaction.coa.type !== 'ACCOUNT' || !props.negator || Math.sign(transaction.amount) === props.negator))) // special casing for transfers - drop one side of a transfer
        ||
            (transaction.split && transaction.split.items &&
                transaction.split.items.find((splitItem) => props.coas.find((coa) => coa.type === splitItem.coa.type && coa.id === splitItem.coa.id
                    && (splitItem.coa.type !== 'ACCOUNT' || !props.negator || Math.sign(splitItem.amount) === props.negator))) // special casing for transfers - drop one side of a transfer
            )) : false; // keepTransaction;
    return keepTransaction;
};
const transactionFilterPropsCached = (0, memoize_one_1.default)((startDate, endDate, coas, accountIds, negator, excludedAccounts) => ({
    startDate,
    endDate,
    coas,
    accountIds,
    negator,
    filterFn: transactionFilterFn,
    filterFnGUID: transactionFilterFnGUID,
    excludedAccounts,
}));
const BudgetWrapper = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const location = (0, react_router_dom_1.useLocation)();
    const query = location.search ? query_string_1.default.parse(location.search) : {};
    const queryBudgetId = (query === null || query === void 0 ? void 0 : query.displayBudget) ? query.displayBudget : null;
    const queryBudgetNodeKey = (query === null || query === void 0 ? void 0 : query.displayNode) ? query.displayNode : null;
    const preferences = (0, react_redux_1.useSelector)((state) => preferencesSelectors.getPreferences(state));
    const sharedDatasetPreferences = preferences && preferences.shared.dataset;
    const lastViewedBudgetId = sharedDatasetPreferences && sharedDatasetPreferences.budgetOptions && sharedDatasetPreferences.budgetOptions.lastViewedBudgetId;
    const budgets = (0, react_redux_1.useSelector)((state) => budgetsSelectors.getBudgets(state));
    let budget = queryBudgetId && budgets.get(queryBudgetId);
    budget = budget || budgets.get(lastViewedBudgetId);
    budget = budget || (budgets && budgets.first());
    const budgetTreeNodes = (0, react_redux_1.useSelector)((state) => {
        if (!budget || !props.uiState || !props.uiState.startDate || !props.uiState.endDate) {
            return null;
        }
        return budgetsSelectors.getBudgetTreeNodes(state, {
            budget,
            startDate: props.uiState.startDate,
            endDate: props.uiState.endDate,
        });
    });
    const navigationPath = budgetTreeNodes && queryBudgetNodeKey && budgetsSelectors.pathToNodeWithKey(budgetTreeNodes, queryBudgetNodeKey);
    const budgetTreeNode = navigationPath && navigationPath.length > 0 && navigationPath[navigationPath.length - 1];
    const coas = budgetTreeNode ? budgetTreeNode.coas : budgetTreeNodes && budgetsSelectors.coasForNodes(budgetTreeNodes);
    const accountIds = budget && budget.filterAccountIds && budget.filterAccountIds.map((account) => account.id);
    const allAccounts = (0, react_redux_1.useSelector)((state) => accountIds ? accounts_1.accountsSelectors.getAccountsById(state) : null);
    const excludedAccounts = (0, react_redux_1.useSelector)((state) => accountIds ? (0, accountsSelectors_1.getExcludedBudgetAccounts)(state).map((account) => account.id) : null);
    const budgetAccounts = accountIds && allAccounts && allAccounts.filter((account) => accountIds.includes(account.id) && account.currency === (budget === null || budget === void 0 ? void 0 : budget.currency));
    const budgetAccountIds = (budgetAccounts && budgetAccounts.map((account) => account.id)) || (0, immutable_1.List)([]);
    const negator = (budgetTreeNode && budgetTreeNode.negate) || undefined;
    let transactions = (0, react_redux_1.useSelector)((state) => {
        if (!(props.uiState && props.uiState.startDate && props.uiState.endDate && coas && budgetAccountIds)) {
            return null;
        }
        return (0, selectors_1.getTransactionsByFilterFn)(state, transactionFilterPropsCached(props.uiState.startDate, props.uiState.endDate, coas, budgetAccountIds, negator, excludedAccounts));
    });
    transactions = transactions && transactions.filter((txn) => !(0, utils_1.isBankOwnedPending)(txn));
    const loadPendingBudgets = (0, react_redux_1.useSelector)((state) => budgetsSelectors.getLoadPending(state));
    const loadPendingCategories = (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getLoadPending(state));
    const loadPendingBudgetItems = (0, react_redux_1.useSelector)((state) => budget_items_1.budgetItemsSelectors.getLoadPending(state));
    const loadPendingCategoryGroups = (0, react_redux_1.useSelector)((state) => categoryGroupsSelectors.getLoadPending(state));
    const loadPendingCategoryGroupLists = (0, react_redux_1.useSelector)((state) => categoryGroupListsSelectors.getLoadPending(state));
    const isLoadingBudgets = (0, react_redux_1.useSelector)((state) => budgetsSelectors.getIsLoading(state));
    const isLoadingCategories = (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getIsLoading(state));
    const isLoadingBudgetItems = (0, react_redux_1.useSelector)((state) => budget_items_1.budgetItemsSelectors.getIsLoading(state));
    const isLoadingCategoryGroups = (0, react_redux_1.useSelector)((state) => categoryGroupsSelectors.getIsLoading(state));
    const isLoadingCategoryGroupLists = (0, react_redux_1.useSelector)((state) => categoryGroupListsSelectors.getIsLoading(state));
    const selectorStates = {
        budget,
        budgets,
        preferences,
        transactions,
        navigationPath,
        budgetTreeNode,
        budgetTreeNodes,
        budgetAccountIds,
        dashboardRef: (query === null || query === void 0 ? void 0 : query.ref) ? query.ref : null,
        budgetItems: (0, react_redux_1.useSelector)((state) => budget_items_1.budgetItemsSelectors.getBudgetItems(state)),
        isWebFirstDataset: (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getIsWebfirstDataset(state)),
        categoryGroups: (0, react_redux_1.useSelector)((state) => categoryGroupsSelectors.getCategoryGroupsById(state)),
        hasReportableAccounts: (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state)),
        budgetsEnabled: (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('budgets')),
        categoryGroupLists: (0, react_redux_1.useSelector)((state) => categoryGroupListsSelectors.getCategoryGroupLists(state)),
        budgetsCreation: (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('budgetsCreation')),
        isLoading: Boolean(isLoadingBudgets || isLoadingBudgetItems || isLoadingCategoryGroups || isLoadingCategoryGroupLists || isLoadingCategories),
        loadPending: Boolean(loadPendingBudgets || loadPendingBudgetItems || loadPendingCategoryGroups || loadPendingCategoryGroupLists || loadPendingCategories),
    };
    const dispatchActions = {
        dispatchGetBudgetsAction: () => dispatch((0, budgetsActions_1.getBudgetsAction)()),
        dispatchGetCategoryGroupsAction: () => dispatch((0, categoryGroupsActions_1.getCategoryGroupsAction)()),
        dispatchDeleteBudgetAction: (data) => dispatch((0, budgetsActions_1.deleteBudgetsAction)([data])),
        dispatchGetCategoriesAction: () => dispatch(categories_1.categoriesActions.getCategories()),
        dispatchGetCategoryGroupListsAction: () => dispatch((0, categoryGroupListsActions_1.getCategoryGroupListsAction)()),
        dispatchBudgetFullCalcCall: (budgetId) => dispatch((0, budgetsActions_1.callFullCalcBudgetAction)(budgetId)),
        dispatchGetBudgetItemsAction: () => dispatch(budget_items_1.budgetItemsActions.getBudgetItemsAction()),
        dispatchSetSharedWebAppDatasetPreferenceAction: (objPreference) => dispatch((0, actions_1.setPreference)({
            section: 'shared',
            group: 'dataset',
            preference: { webApp: objPreference },
        }, { context: 'QPreferences:setDatasetPreference' })),
        dispatchGetPreferencesAction: () => dispatch((0, actions_1.getPreferences)({ section: 'shared', group: 'dataset' })),
        dispatchGetUserPreferencesAction: () => dispatch((0, actions_1.getPreferences)({ section: 'shared', group: 'user' })),
        dispatchGetTransactionsAction: () => dispatch(transactions_1.transactionsActions.getTransactions(undefined, { context: 'budgets' })),
        dispatchCreateBudgetAction: (data) => dispatch((0, budgetsActions_1.createBudgetsAction)([data], { undo: { userMessage: 'New budget created.' } })),
        dispatchSetUserPreferenceAction: (preference) => dispatch((0, actions_1.setPreference)({ section: 'shared', group: 'user', preference })),
        dispatchSetSharedDatasetPreferenceAction: (preference) => dispatch((0, actions_1.setPreference)({ section: 'shared', group: 'dataset', preference })),
        dispatchCreateBudgetItemsAction: (data) => dispatch(budget_items_1.budgetItemsActions.createBudgetItemsAction(data, { undo: { userMessage: 'Budget items created' } })),
    };
    const propsToPass = Object.assign(Object.assign(Object.assign({}, props), selectorStates), dispatchActions);
    return <BudgetsV2_1.default {...propsToPass}/>;
};
const BudgetsUIState = (0, immutable_1.Record)({
    startDate: null,
    endDate: null,
    selectedAnnualBudgetItem: null,
    selectedMonthDate: null,
});
const uiStateConfig = {
    name: 'Budgets',
    state: () => new BudgetsUIState(),
    persist: false,
};
exports.default = (0, compose_1.default)((0, UIState_1.default)(uiStateConfig), (0, QDialogs_1.default)())((0, react_1.memo)(BudgetWrapper));
